import React from 'react';
import PropTypes from 'prop-types';
import { required as validationRequired } from 'form/validation';
import takeoverStatuses from 'enums/takeoverStatuses';
import takeoverTenantSelections from 'enums/takeoverTenantSelections';
import { getBusinessOrPrivateName } from 'helpers/ActorHelper';

import { TextField, Checkboxes, showErrorOnBlur } from 'mui-rff';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import ShortDateTime from 'common/ShortDateTime';

const EmailFormFields = ({ takeover, selections, formValues, required = false }) => {
    const fieldProps = required
        ? { validate: validationRequired }
        : undefined;

    const bodyHelperText = (
            takeover.status === takeoverStatuses.draft
                ? 'Codes that can be used: {name}, {storageSiteTitle}, {storageTitle}.'
                : 'Use {link} to define a unique registration+payment link for the tenant. Other codes that can be used: {name}, {storageSiteTitle}, {storageTitle}.'
        )
        + ' The message will be wrapped in the standard email template with a Storage365 logotype and footer.';

    return (
        <>
            <TextField
                name="subject"
                label="Subject"
                type="text"
                variant="outlined"
                required={required}
                fieldProps={fieldProps}
                showError={showErrorOnBlur}
            />
            <TextField
                name="body"
                label="Body"
                type="text"
                variant="outlined"
                multiline
                rows={10}
                required={required}
                fieldProps={fieldProps}
                showError={showErrorOnBlur}
                helperText={bodyHelperText}
            />
            <TextField
                select
                name="filter.selection"
                label="Selection of tenants"
                variant="outlined"
            >
                {
                    selections.map(o => (
                        <MenuItem key={o.key} value={o.key}>
                            {o.label}
                        </MenuItem>
                    ))
                }
            </TextField>

            {
                formValues.filter.selection === takeoverTenantSelections.custom.key &&
                (
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Tenant name</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Booking created time</TableCell>
                                <TableCell>User created time</TableCell>
                                <TableCell>Payment due time</TableCell>
                                <TableCell>Payment time</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                formValues.filter.customSelectedTakeoverTenantItems.map((item, i) => (
                                    <TableRow key={item.tenant.id}>
                                        <TableCell>
                                            <Checkboxes
                                                name={`filter.customSelectedTakeoverTenantItems[${i}].selected`}
                                                data={{
                                                    label: getBusinessOrPrivateName(item.tenant),
                                                    value: true
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            {item.tenant.status}
                                        </TableCell>
                                        <TableCell>
                                            <ShortDateTime value={item.tenant.initialPurchaseCreatedTime} />
                                        </TableCell>
                                        <TableCell>
                                            <ShortDateTime value={item.tenant.userCreatedTime} />
                                        </TableCell>
                                        <TableCell>
                                            <ShortDateTime value={item.tenant.initialPurchaseDueTime} />
                                        </TableCell>
                                        <TableCell>
                                            <ShortDateTime value={item.tenant.initialPurchasePaidTime} />
                                        </TableCell>
                                    </TableRow>
                                ))
                            }
                        </TableBody>
                    </Table>
                )
            }
        </>
    );
};

EmailFormFields.propTypes = {
    takeover: PropTypes.object.isRequired,
    selections: PropTypes.array.isRequired,
    formValues: PropTypes.object.isRequired,
    required: PropTypes.bool
};

export default EmailFormFields;
